var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.currentValue},on:{"change":_vm.change}}),_vm._v(" 单独选项 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }